module.exports = __webpack_public_path__ + "static/media/research-good-data-icon.b25e59f4.png";